import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { MainLayout } from '../components/Layout';
import ReservationsTable from '../components/records/ReservationsTable';
import IssuableTable from '../components/records/IssuableTable';
import PurchasesTable from '../components/records/PurchasesTable';
import TopBarComponent from '../components/records/TopBar';
import SearchBar from '../components/records/SearchBar';
import WorkbenchesBookingTable from '../components/records/WorkbenchesBookingTable';

const Records = ({ collapsed, setCollapsed }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [category, setCategory] = React.useState([]);

  const renderTable = () => {
    switch (activeTab) {
      case 0:
        return (
          <ReservationsTable searchQuery={searchQuery} category={category} />
        );
      case 1:
        return <IssuableTable searchQuery={searchQuery} category={category} />;
      case 2:
        return <PurchasesTable searchQuery={searchQuery} category={category} />;
      case 3: // New Workbenches tab
        return (
          <WorkbenchesBookingTable
            searchQuery={searchQuery}
            category={category}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
      <TopBarComponent activeTab={activeTab} setActiveTab={setActiveTab} />
      {/* <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} category={category} setCategory={setCategory}/> */}
      {renderTable()}
    </MainLayout>
  );
};

export default Records;
